/**
 * Custom Judge.me Review Widget Enhancer
 * Clean 3-Column Header & Review Cards Layout
 */
(function () {
  'use strict';

  let isUpdating = false;
  let isOpeningModal = false;
  let isTriggeringNativeClick = false;

  function setupJdgmOverrides() {
    window.jdgmSettings = window.jdgmSettings || {};
    window.jdgmSettings.widget_show_photo_gallery = false;
    window.jdgmSettings.closeForm = function () {
      if (!isOpeningModal) {
        closeReviewModal();
      }
    };
    if (window.jdgm) {
      window.jdgm.closeForm = function () {
        if (!isOpeningModal) {
          closeReviewModal();
        }
      };
    }
  }
  setupJdgmOverrides();

  let enhancerTimer = null;
  function runEnhancer() {
    // Merge event/observer bursts without postponing the pending update.
    if (enhancerTimer !== null) return;
    enhancerTimer = setTimeout(function () {
      enhancerTimer = null;
      enhanceNow();
    }, 50);
  }

  function enhanceNow() {
    if (isUpdating) return;
    isUpdating = true;
    try {
      initCustomJudgeMe();
      enhanceProductTitleBadge();
    } catch (err) {
      console.warn('Custom Judge.me layout warning:', err);
    } finally {
      setTimeout(function () {
        isUpdating = false;
      }, 200);
    }
  }

  function enhanceProductTitleBadge() {
    const badges = document.querySelectorAll('.product-meta-subrow .jdgm-preview-badge, .product-title .jdgm-preview-badge, .product-single__title + .jdgm-preview-badge');
    if (!badges || badges.length === 0) return;

    const widget = document.querySelector('.jdgm-rev-widg');

    badges.forEach(function (badge) {
      const prevBadge = badge.querySelector('.jdgm-prev-badge');

      let numReviews = 0;
      let avgRating = 0;

      if (prevBadge && prevBadge.getAttribute('data-number-of-reviews') !== null) {
        numReviews = parseInt(prevBadge.getAttribute('data-number-of-reviews'), 10);
        avgRating = parseFloat(prevBadge.getAttribute('data-average-rating') || '0');
      } else if (badge.getAttribute('data-number-of-reviews') !== null) {
        numReviews = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
        avgRating = parseFloat(badge.getAttribute('data-average-rating') || '0');
      } else if (widget) {
        numReviews = parseInt(widget.getAttribute('data-number-of-reviews') || '0', 10);
        avgRating = parseFloat(widget.getAttribute('data-average-rating') || '0');
      }

      const subrow = badge.closest('.product-meta-subrow');
      const divider = subrow ? subrow.querySelector('.product-sku-divider') : null;
      const skuWrap = subrow ? subrow.querySelector('.product-meta-subrow__sku') : null;
      const skuVal = subrow ? subrow.querySelector('.js-variant-sku') : null;

      // Check if SKU exists
      const hasSku = skuVal && skuVal.textContent.trim() !== '';
      if (skuWrap) {
        if (hasSku) {
          skuWrap.classList.remove('d-none');
          skuWrap.style.removeProperty('display');
        } else {
          skuWrap.classList.add('d-none');
          skuWrap.style.setProperty('display', 'none', 'important');
        }
      }

      // 1. Neither reviews nor SKU exist: hide entire subrow completely
      if (numReviews === 0 && !hasSku) {
        badge.style.setProperty('display', 'none', 'important');
        if (divider) divider.style.setProperty('display', 'none', 'important');
        if (subrow) {
          subrow.classList.add('is-empty', 'd-none');
          subrow.style.setProperty('display', 'none', 'important');
          subrow.style.setProperty('margin', '0', 'important');
          subrow.style.setProperty('min-height', '0', 'important');
          subrow.style.setProperty('height', '0', 'important');
          subrow.style.setProperty('padding', '0', 'important');
        }
        return;
      }

      // At least one of reviews or SKU exists: ensure subrow is visible
      if (subrow) {
        subrow.classList.remove('is-empty', 'd-none');
        subrow.style.removeProperty('display');
        subrow.style.removeProperty('margin');
        subrow.style.removeProperty('min-height');
        subrow.style.removeProperty('height');
        subrow.style.removeProperty('padding');
      }

      // 2. Zero reviews condition (but SKU exists): hide badge and divider, show SKU
      if (numReviews === 0) {
        badge.style.setProperty('display', 'none', 'important');
        if (divider) divider.style.setProperty('display', 'none', 'important');
        return;
      }

      // 2. Reviews exist: display badge and divider only if SKU also exists
      badge.style.setProperty('display', 'inline-flex', 'important');
      badge.style.setProperty('pointer-events', 'none', 'important');
      badge.style.setProperty('cursor', 'default', 'important');
      if (divider) {
        if (hasSku) {
          divider.style.setProperty('display', 'inline-block', 'important');
        } else {
          divider.style.setProperty('display', 'none', 'important');
        }
      }

      // 3. Make non-clickable and format text as "4.8 (6 Reviews)"
      if (prevBadge) {
        prevBadge.removeAttribute('href');
        prevBadge.style.setProperty('pointer-events', 'none', 'important');
        prevBadge.style.setProperty('cursor', 'default', 'important');
        prevBadge.style.setProperty('text-decoration', 'none', 'important');

        if (!prevBadge.dataset.clickPrevented) {
          prevBadge.dataset.clickPrevented = 'true';
          prevBadge.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
          });
        }

        const textEl = prevBadge.querySelector('.jdgm-prev-badge__text');
        if (textEl) {
          const scoreStr = (!isNaN(avgRating) && avgRating > 0) ? avgRating.toFixed(1) : '5.0';
          textEl.textContent = `${scoreStr} (${numReviews} ${numReviews === 1 ? 'Review' : 'Reviews'})`;
        }
      }
    });
  }

  function initCustomJudgeMe() {
    const widget = document.querySelector('.jdgm-rev-widg');
    if (!widget) return;

    // 0. Ensure 1645px width on widget and its wrapping container
    widget.style.setProperty('max-width', '1645px', 'important');
    widget.style.setProperty('width', '100%', 'important');

    const rootWidg = widget.closest('#judgeme_product_reviews') || widget.closest('.jdgm-widget');
    if (rootWidg) {
      rootWidg.style.setProperty('max-width', '1645px', 'important');
      rootWidg.style.setProperty('width', '100%', 'important');
    }

    const parentBlock = widget.closest('.shopify-app-block') || widget.closest('.shopify-block');
    if (parentBlock) {
      parentBlock.style.setProperty('max-width', '1645px', 'important');
      parentBlock.style.setProperty('width', '100%', 'important');
    }

    const parentContainer = widget.closest('.container');
    if (parentContainer) {
      parentContainer.style.setProperty('max-width', '1645px', 'important');
      parentContainer.style.setProperty('width', '100%', 'important');
    }

    // 1. Ensure Title is "Customer Reviews"
    let titleEl = widget.querySelector('.jdgm-rev-widg__title');
    if (!titleEl) {
      titleEl = document.createElement('h2');
      titleEl.className = 'jdgm-rev-widg__title custom-judgeme-title';
      widget.insertBefore(titleEl, widget.firstChild);
    }
    if (titleEl.textContent !== 'Customer Reviews') {
      titleEl.textContent = 'Customer Reviews';
    }

    // 2. Hide unwanted native Judge.me elements
    hideNativeElements(widget);

    // 3. Build or Update 3-Column Top Summary
    enhanceTopSummary(widget);

    // 4. Remove Customer Photos & Videos Gallery / Thumbnails Row
    removeTopMediaGallery(widget);

    // 5. Build or Update Toolbar (Review count & Sort)
    enhanceToolbar(widget);

    // 6. Transform Review Cards into 3-Column Grid
    enhanceReviewCards(widget);

    // 7. Remove any See All Reviews button if present
    const seeAllBtn = widget.querySelector('.custom-see-all-wrapper');
    if (seeAllBtn) seeAllBtn.remove();

    // 8. Observe reviews list for dynamic AJAX pagination
    observeReviewsList(widget);
  }

  function hideNativeElements(widget) {
    const header = widget.querySelector('.jdgm-rev-widg__header');
    if (header) {
      const children = header.children;
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        // ONLY allow custom title and custom-summary-container in header
        if (
          !child.classList.contains('jdgm-rev-widg__title') &&
          !child.classList.contains('custom-summary-container')
        ) {
          child.style.setProperty('display', 'none', 'important');
        }
      }
    }

    const nativeUnwanted = widget.querySelectorAll(
      '.jdgm-histogram, .jdgm-write-rev-link, .jdgm-rev-widg__summary, .jdgm-sort-dropdown, .jdgm-sort-dropdown-wrapper, .jdgm-subtab, .jdgm-filter-subtab, [class*="jdgm-subtab"], [class*="jdgm-sort"]'
    );
    nativeUnwanted.forEach(function (el) {
      if (!el.closest('.custom-summary-container') && !el.closest('.custom-toolbar-row')) {
        el.style.setProperty('display', 'none', 'important');
      }
    });

    // Ensure form is hidden on page while inside widget (only shows when moved to modal)
    const widgetForms = widget.querySelectorAll('.jdgm-form-wrapper, .jdgm-form');
    widgetForms.forEach(function (f) {
      if (!f.closest('.custom-review-modal-body')) {
        f.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function enhanceTopSummary(widget) {
    const header = widget.querySelector('.jdgm-rev-widg__header');
    if (!header) return;

    // Extract stats accurately
    const avgRatingRaw = widget.getAttribute('data-average-rating') || '0';
    const numReviewsRaw = widget.getAttribute('data-number-of-reviews') || '0';
    const parsedReviews = parseInt(numReviewsRaw, 10);
    const numReviews = isNaN(parsedReviews) ? 0 : parsedReviews;
    const parsedRating = parseFloat(avgRatingRaw);
    const avgRating = (!isNaN(parsedRating) && parsedRating > 0) ? parsedRating.toFixed(1) : (numReviews > 0 ? '5.0' : '0.0');

    // Check if summary container already exists
    let summaryContainer = header.querySelector('.custom-summary-container');
    if (!summaryContainer) {
      summaryContainer = document.createElement('div');
      summaryContainer.className = 'custom-summary-container';
      header.appendChild(summaryContainer);
    }

    // ----------------------------------------------------
    // Column 1: Rating Snapshot (Left Side)
    // ----------------------------------------------------
    let col1 = summaryContainer.querySelector('.custom-snapshot-col');
    if (!col1) {
      col1 = document.createElement('div');
      col1.className = 'custom-snapshot-col';
      col1.innerHTML = `
        <div class="custom-summary-col-title">Rating Snapshot</div>
        <div class="custom-summary-col-subtitle">Select a row below to filter reviews.</div>
        <div class="custom-snapshot-list"></div>
      `;
      summaryContainer.appendChild(col1);
    }

    // Populate rows (5 down to 1)
    const snapshotList = col1.querySelector('.custom-snapshot-list');
    if (snapshotList) {
      snapshotList.innerHTML = '';
      const nativeHistogram = header.querySelector('.jdgm-histogram');

      for (let star = 5; star >= 1; star--) {
        let count = 0;
        let percentage = 0;
        let nativeRow = null;

        if (nativeHistogram) {
          nativeRow = nativeHistogram.querySelector(`.jdgm-histogram__row[data-rating="${star}"]`);
          if (nativeRow) {
            count = parseInt(nativeRow.getAttribute('data-frequency') || '0', 10);
            percentage = parseInt(nativeRow.getAttribute('data-percentage') || '0', 10);
            if (isNaN(percentage) && numReviews > 0) {
              percentage = Math.round((count / numReviews) * 100);
            }
          }
        }

        const rowEl = document.createElement('div');
        rowEl.className = 'custom-snapshot-row';
        rowEl.setAttribute('data-rating', star);
        rowEl.innerHTML = `
          <span class="custom-snapshot-star-label">${star === 1 ? '1 star' : star + ' stars'}</span>
          <div class="custom-snapshot-bar-wrap">
            <div class="custom-snapshot-bar-fill" style="width: ${percentage}%;"></div>
          </div>
          <span class="custom-snapshot-freq">${count}</span>
        `;

        if (nativeRow) {
          rowEl.addEventListener('click', function () {
            nativeRow.click();
            setTimeout(runEnhancer, 300);
          });
        }

        snapshotList.appendChild(rowEl);
      }
    }

    // ----------------------------------------------------
    // Column 2: Overall Rating (Center)
    // ----------------------------------------------------
    let col2 = summaryContainer.querySelector('.custom-overall-col');
    if (!col2) {
      col2 = document.createElement('div');
      col2.className = 'custom-overall-col';
      summaryContainer.appendChild(col2);
    }

    col2.innerHTML = '';

    const col2Title = document.createElement('div');
    col2Title.className = 'custom-summary-col-title';
    col2Title.textContent = 'Overall Rating';

    const scoreRow = document.createElement('div');
    scoreRow.className = 'custom-overall-score-row';

    const scoreNum = document.createElement('div');
    scoreNum.className = 'custom-overall-number';
    scoreNum.textContent = avgRating;

    const starsWrap = document.createElement('div');
    starsWrap.className = 'custom-overall-stars-wrap';

    const roundedRating = Math.round(parseFloat(avgRating));
    for (let i = 1; i <= 5; i++) {
      const star = document.createElement('span');
      star.className = 'jdgm-star ' + (numReviews > 0 && i <= roundedRating ? 'jdgm--on' : 'jdgm--off');
      starsWrap.appendChild(star);
    }

    const countText = document.createElement('span');
    countText.className = 'custom-overall-review-count';
    countText.textContent = `${numReviews} Reviews`;
    starsWrap.appendChild(countText);

    scoreRow.appendChild(scoreNum);
    scoreRow.appendChild(starsWrap);

    const recommendText = document.createElement('div');
    recommendText.className = 'custom-overall-recommend';
    if (numReviews > 0) {
      recommendText.textContent = `${numReviews} out of ${numReviews} (100%) reviewers recommend this product.`;
    } else {
      recommendText.textContent = 'Be the first to review this product.';
    }

    col2.appendChild(col2Title);
    col2.appendChild(scoreRow);
    col2.appendChild(recommendText);

    // ----------------------------------------------------
    // Column 3: Write a Review Button (Right Side - Clean)
    // ----------------------------------------------------
    let col3 = summaryContainer.querySelector('.custom-write-col');
    if (!col3) {
      col3 = document.createElement('div');
      col3.className = 'custom-write-col';

      const writeBtn = document.createElement('button');
      writeBtn.type = 'button';
      writeBtn.className = 'custom-write-review-btn';
      writeBtn.textContent = 'Write a Review';
      writeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openReviewModal(widget);
      });

      col3.appendChild(writeBtn);
      summaryContainer.appendChild(col3);
    }
  }

  function removeTopMediaGallery(widget) {
    const mediaElements = widget.querySelectorAll(
      '.jdgm-row-media, .jdgm-gallery-wrapper, .jdgm-gallery, .jdgm-gallery-title, .custom-gallery-title, .custom-gallery-see-more, .jdgm-media-grid, .jdgm-rev-widg__media-grid, .jdgm-carousel-wrapper, .jdgm-ugc-media-wrapper'
    );
    mediaElements.forEach(function (el) {
      el.remove();
    });
  }

  function enhanceToolbar(widget) {
    const body = widget.querySelector('.jdgm-rev-widg__body') || widget.querySelector('.jdgm-rev-widg__reviews');
    if (!body) return;

    const numReviewsRaw = widget.getAttribute('data-number-of-reviews') || '0';
    const totalCount = parseInt(numReviewsRaw, 10) || 0;
    const revs = widget.querySelectorAll('.jdgm-rev');

    let toolbar = widget.querySelector('.custom-toolbar-row');
    if (toolbar) {
      const countEl = toolbar.querySelector('.custom-toolbar-count');
      if (countEl) {
        countEl.textContent = totalCount > 0 ? `1–${revs.length} of ${totalCount} Reviews` : '0 Reviews';
      }
      return;
    }

    toolbar = document.createElement('div');
    toolbar.className = 'custom-toolbar-row';

    const countEl = document.createElement('div');
    countEl.className = 'custom-toolbar-count';
    countEl.textContent = totalCount > 0 ? `1–${revs.length} of ${totalCount} Reviews` : '0 Reviews';

    const sortEl = document.createElement('div');
    sortEl.className = 'custom-sort-wrapper';
    sortEl.innerHTML = `
      <label style="margin-right: 6px; font-weight: 500; font-size: 13px;">Sort by:</label>
      <select class="custom-sort-select">
        <option value="most-relevant">Most relevant</option>
        <option value="highest-rating">Highest rating</option>
        <option value="lowest-rating">Lowest rating</option>
        <option value="newest">Newest</option>
      </select>
    `;

    // Connect custom sort dropdown to native sort dropdown if present
    const sortSelect = sortEl.querySelector('select');
    sortSelect.addEventListener('change', function () {
      const nativeSort = widget.querySelector('.jdgm-sort-dropdown');
      if (nativeSort) {
        nativeSort.value = this.value;
        nativeSort.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    toolbar.appendChild(countEl);
    toolbar.appendChild(sortEl);

    body.parentNode.insertBefore(toolbar, body);
  }

  function enhanceReviewCards(widget) {
    const reviews = widget.querySelectorAll('.jdgm-rev:not(.custom-card-processed)');
    if (!reviews || reviews.length === 0) return;

    reviews.forEach(function (rev) {
      rev.classList.add('custom-card-processed');

      const authorName = (rev.querySelector('.jdgm-rev__author')?.textContent || 'Verified Customer').trim();
      const timestampEl = rev.querySelector('.jdgm-rev__timestamp');
      let dateText = 'Recently';
      if (timestampEl) {
        const dt = timestampEl.getAttribute('datetime') || timestampEl.textContent;
        if (dt) {
          const parsedDate = new Date(dt);
          if (!isNaN(parsedDate.getTime())) {
            const mm = String(parsedDate.getMonth() + 1).padStart(2, '0');
            const dd = String(parsedDate.getDate()).padStart(2, '0');
            const yy = String(parsedDate.getFullYear()).slice(-2);
            dateText = `${mm}/${dd}/${yy}`;
          }
        }
      }

      const ratingScore = parseInt(
        rev.querySelector('.jdgm-rev__rating')?.getAttribute('data-score') || 
        rev.getAttribute('data-score') || 
        '5', 
        10
      );
      const starCount = isNaN(ratingScore) ? 5 : ratingScore;
      const starText = `${starCount} ${starCount === 1 ? 'Star' : 'Stars'}`;
      const titleText = (rev.querySelector('.jdgm-rev__title')?.textContent || '').trim();
      const bodyHtml = rev.querySelector('.jdgm-rev__body')?.innerHTML || '';

      let thumbUp = '0';
      let thumbDown = '0';
      const upCount = rev.getAttribute('data-thumb-up-count');
      const downCount = rev.getAttribute('data-thumb-down-count');
      if (upCount) thumbUp = upCount;
      if (downCount) thumbDown = downCount;

      const customFormEl = rev.querySelector('.jdgm-rev__custom-form');
      let criteriaList = [];
      if (customFormEl && customFormEl.children.length > 0) {
        const cfItems = customFormEl.querySelectorAll('.jdgm-rev__custom-form-field');
        cfItems.forEach(function (item) {
          const q = item.querySelector('.jdgm-rev__custom-form-question')?.textContent?.trim();
          const a = item.querySelector('.jdgm-rev__custom-form-answer')?.textContent?.trim();
          if (q) {
            criteriaList.push({ name: q, score: parseFloat(a) || ratingScore });
          }
        });
      }

      if (criteriaList.length === 0) {
        criteriaList = [
          { name: 'Product Performance', score: (ratingScore >= 4 ? 5.0 : ratingScore).toFixed(1) },
          { name: 'Value of Product', score: (ratingScore >= 4 ? 5.0 : ratingScore).toFixed(1) }
        ];
      }

      // Column 1: Reviewer Details
      const colAuthor = document.createElement('div');
      colAuthor.className = 'custom-rev-col-author';
      colAuthor.innerHTML = `
        <div class="custom-rev-author-name">${escapeHtml(authorName)}</div>
        <div class="custom-rev-verified-badge">
          <svg viewBox="0 0 16 16"><path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/></svg>
          Verified Buyer
        </div>
        <div class="custom-rev-count-text">${starText}</div>
        <div class="custom-rev-date">${dateText}</div>
      `;

      // Column 2: Content
      const colContent = document.createElement('div');
      colContent.className = 'custom-rev-col-content';

      const starsDiv = document.createElement('div');
      starsDiv.className = 'custom-rev-stars';
      for (let s = 1; s <= 5; s++) {
        const st = document.createElement('span');
        st.className = 'jdgm-star ' + (s <= ratingScore ? 'jdgm--on' : 'jdgm--off');
        starsDiv.appendChild(st);
      }
      colContent.appendChild(starsDiv);

      if (titleText) {
        const titleEl = document.createElement('div');
        titleEl.className = 'custom-rev-title';
        titleEl.textContent = titleText;
        colContent.appendChild(titleEl);
      }

      const bodyDiv = document.createElement('div');
      bodyDiv.className = 'custom-rev-body';
      bodyDiv.innerHTML = bodyHtml;
      colContent.appendChild(bodyDiv);

      // Preserve native Judge.me review photos, videos, and media
      const picsEl = rev.querySelector('.jdgm-rev__pics');
      if (picsEl) {
        colContent.appendChild(picsEl);
      }
      const vidsEl = rev.querySelector('.jdgm-rev__vids');
      if (vidsEl) {
        colContent.appendChild(vidsEl);
      }
      const mediaEl = rev.querySelector('.jdgm-rev__media');
      if (mediaEl && mediaEl !== picsEl && mediaEl !== vidsEl) {
        colContent.appendChild(mediaEl);
      }

      // Column 3: Criteria
      const colCriteria = document.createElement('div');
      colCriteria.className = 'custom-rev-col-criteria';

      criteriaList.forEach(function (crit) {
        const critVal = parseFloat(crit.score) || 5;
        const filledCount = Math.min(5, Math.max(1, Math.round(critVal)));

        const item = document.createElement('div');
        item.className = 'custom-criteria-item';

        let segmentsHtml = '';
        for (let b = 1; b <= 5; b++) {
          segmentsHtml += `<div class="custom-bar-segment ${b <= filledCount ? 'filled' : ''}"></div>`;
        }

        item.innerHTML = `
          <div class="custom-criteria-label">${escapeHtml(crit.name)}</div>
          <div class="custom-criteria-bar-row">
            <div class="custom-segmented-bar">${segmentsHtml}</div>
            <div class="custom-criteria-score">${critVal.toFixed(1)}</div>
          </div>
        `;
        colCriteria.appendChild(item);
      });

      rev.appendChild(colAuthor);
      rev.appendChild(colContent);
      rev.appendChild(colCriteria);
    });

    // Guarantee that photos, videos, or store replies are attached to colContent even if loaded asynchronously
    widget.querySelectorAll('.jdgm-rev').forEach(function (rev) {
      const colContent = rev.querySelector('.custom-rev-col-content');
      if (!colContent) return;

      const pics = rev.querySelector('.jdgm-rev__content .jdgm-rev__pics, .jdgm-rev > .jdgm-rev__pics');
      if (pics && !colContent.contains(pics)) {
        colContent.appendChild(pics);
      }
      const vids = rev.querySelector('.jdgm-rev__content .jdgm-rev__vids, .jdgm-rev > .jdgm-rev__vids');
      if (vids && !colContent.contains(vids)) {
        colContent.appendChild(vids);
      }
      const reply = rev.querySelector('.jdgm-rev__reply');
      if (reply && !colContent.contains(reply)) {
        colContent.appendChild(reply);
      }
    });
  }

  function openReviewModal(widget) {
    isOpeningModal = true;
    setTimeout(function () {
      isOpeningModal = false;
    }, 1200);

    setupJdgmOverrides();

    let overlay = document.querySelector('.custom-review-modal-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'custom-review-modal-overlay';
      overlay.innerHTML = `
        <div class="custom-review-modal-box">
          <button type="button" class="custom-review-modal-close" aria-label="Close modal">&times;</button>
          <div class="custom-review-modal-body jdgm-widget jdgm-review-widget"></div>
        </div>
      `;
      document.body.appendChild(overlay);

      const closeBtn = overlay.querySelector('.custom-review-modal-close');
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeReviewModal();
      });

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          e.preventDefault();
          e.stopPropagation();
          closeReviewModal();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
          closeReviewModal();
        }
      });
    }

    const modalBody = overlay.querySelector('.custom-review-modal-body');

    // Show modal immediately
    overlay.classList.add('is-active');
    document.body.classList.add('custom-modal-open');

    function displayAndEnhance(formWrapper) {
      if (!formWrapper) return false;

      // Remove loading indicator if present
      const loader = modalBody.querySelector('.custom-review-loading');
      if (loader) loader.remove();

      if (formWrapper.parentNode !== modalBody) {
        modalBody.appendChild(formWrapper);
      }

      // Stop any ongoing jQuery slideUp animation immediately and show
      if (window.jQuery) {
        try {
          window.jQuery(formWrapper).stop(true, true).show();
        } catch (e) {}
      }

      formWrapper.style.setProperty('display', 'block', 'important');
      formWrapper.style.setProperty('visibility', 'visible', 'important');
      formWrapper.style.setProperty('opacity', '1', 'important');
      formWrapper.style.setProperty('height', 'auto', 'important');

      const innerForm = formWrapper.classList.contains('jdgm-form') ? formWrapper : formWrapper.querySelector('.jdgm-form');
      if (innerForm) {
        innerForm.style.setProperty('display', 'block', 'important');
        innerForm.style.setProperty('visibility', 'visible', 'important');
        innerForm.style.setProperty('opacity', '1', 'important');
        innerForm.style.setProperty('height', 'auto', 'important');
        if (window.jQuery) {
          try {
            window.jQuery(innerForm).stop(true, true).show();
          } catch (e) {}
        }
      }

      hideGdprStatement(formWrapper);
      enhanceMediaUpload(formWrapper);
      enhanceReviewFormElements(formWrapper);

      const cancelBtns = formWrapper.querySelectorAll('.jdgm-cancel-rev, .jdgm-form__cancel, [class*="cancel-rev"]');
      cancelBtns.forEach(function (btn) {
        if (!btn.dataset.modalHooked) {
          btn.dataset.modalHooked = 'true';
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            closeReviewModal();
          });
        }
      });
      return true;
    }

    const targetWidget = widget || document.querySelector('.jdgm-rev-widg') || document.querySelector('#judgeme_product_reviews') || document;

    // 1. Check if form is already anywhere in the DOM
    let existingForm = modalBody.querySelector('.jdgm-form-wrapper, .jdgm-form') ||
                       (widget ? widget.querySelector('.jdgm-form-wrapper, .jdgm-form') : null) ||
                       document.querySelector('.jdgm-form-wrapper, .jdgm-form');

    if (existingForm) {
      displayAndEnhance(existingForm);
      const nativeLink = (widget ? widget.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-btn, [class*="write-rev"]') : null) ||
                         document.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-btn, [class*="write-rev"]');
      if (nativeLink) {
        nativeLink.classList.remove('close-form-btn');
      }
      return;
    }

    // 2. Form does not exist yet: show clean loading state
    if (!modalBody.querySelector('.custom-review-loading')) {
      modalBody.innerHTML = `
        <div class="custom-review-loading">
          <div class="custom-review-spinner"></div>
          <div>Loading review form...</div>
        </div>
      `;
    }

    // 3. Trigger Judge.me to render and open review form:
    // A) Directly call Judge.me's form renderer if available
    if (window.jdgm && typeof window.jdgm._renderAndSetupReviewForm === 'function' && window.jQuery) {
      try {
        window.jdgm._renderAndSetupReviewForm(window.jQuery(targetWidget));
      } catch (err) {}
    }

    // B) Directly call Judge.me's openForm if available
    if (window.jdgm && typeof window.jdgm.openForm === 'function') {
      try {
        window.jdgm.openForm(window.jQuery ? window.jQuery(targetWidget) : targetWidget);
      } catch (err) {}
    }

    // C) Trigger native write review button safely (flag prevents recursion)
    const nativeBtn = (widget ? widget.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-btn, [class*="write-rev"]') : null) ||
                      document.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-btn, [class*="write-rev"]');
    if (nativeBtn) {
      nativeBtn.classList.remove('close-form-btn');
      isTriggeringNativeClick = true;
      try {
        nativeBtn.click();
      } catch (err) {}
      setTimeout(function () {
        isTriggeringNativeClick = false;
      }, 100);
    }

    // D) Fallback: If form still not created after 150ms, inject Judge.me template directly
    setTimeout(function () {
      let currentForm = modalBody.querySelector('.jdgm-form-wrapper, .jdgm-form') ||
                        document.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (!currentForm && window.jdgm && window.jdgm.templates && typeof window.jdgm.templates.reviewForm === 'function') {
        try {
          const formHtml = window.jdgm.templates.reviewForm();
          const temp = document.createElement('div');
          temp.innerHTML = formHtml;
          const injected = temp.querySelector('.jdgm-form-wrapper') || temp.firstElementChild;
          if (injected) {
            modalBody.appendChild(injected);
            displayAndEnhance(injected);
            if (typeof window.jdgm.setupReviewFormValidation === 'function') {
              window.jdgm.setupReviewFormValidation(window.jQuery ? window.jQuery(injected.querySelector('.jdgm-form')) : injected.querySelector('.jdgm-form'));
            }
            if (typeof window.jdgm._setupFormsSubmit === 'function') {
              window.jdgm._setupFormsSubmit(window.jQuery ? window.jQuery(injected) : injected);
            }
          }
        } catch (e) {}
      }
    }, 150);

    // 4. Poll and attach as soon as Judge.me injects the form (poll up to 5 seconds)
    let attempts = 0;
    const pollInterval = setInterval(function () {
      attempts++;
      const form = modalBody.querySelector('.jdgm-form-wrapper, .jdgm-form') ||
                   (widget ? widget.querySelector('.jdgm-form-wrapper, .jdgm-form') : null) ||
                   document.querySelector('.jdgm-form-wrapper, .jdgm-form');
      if (form) {
        displayAndEnhance(form);
        clearInterval(pollInterval);
      } else if (attempts >= 50) {
        clearInterval(pollInterval);
      }
    }, 80);
  }

  function hideGdprStatement(formWrapper) {
    if (!formWrapper) return;
    try {
      // 1. Hide by links to judge.me terms/privacy/content-policy
      const gdprLinks = formWrapper.querySelectorAll('a[href*="judge.me/terms"], a[href*="judge.me/privacy"], a[href*="judge.me/content-policy"]');
      gdprLinks.forEach(function (link) {
        const container = link.closest('.jdgm-form__fieldset') || link.closest('p') || link.closest('div');
        if (container) {
          container.style.setProperty('display', 'none', 'important');
          container.style.setProperty('height', '0', 'important');
          container.style.setProperty('margin', '0', 'important');
          container.style.setProperty('padding', '0', 'important');
          container.style.setProperty('visibility', 'hidden', 'important');
        }
      });

      // 2. Hide by text content match for "How we use your data"
      const allEls = formWrapper.querySelectorAll('p, div, span');
      allEls.forEach(function (el) {
        if (el.textContent && el.textContent.indexOf('How we use your data') !== -1 && el.children.length <= 4) {
          const parentFieldset = el.closest('.jdgm-form__fieldset') || el;
          parentFieldset.style.setProperty('display', 'none', 'important');
          parentFieldset.style.setProperty('height', '0', 'important');
          parentFieldset.style.setProperty('margin', '0', 'important');
          parentFieldset.style.setProperty('padding', '0', 'important');
          parentFieldset.style.setProperty('visibility', 'hidden', 'important');
        }
      });
    } catch (e) {}
  }

  function enhanceMediaUpload(formWrapper) {
    if (!formWrapper) return;

    // Reset default browser fieldset borders
    const fieldsets = formWrapper.querySelectorAll('fieldset, .jdgm-picture-fieldset, .jdgm-media-fieldset__container, .jdgm-form__fieldset');
    fieldsets.forEach(function (fs) {
      fs.style.setProperty('border', 'none', 'important');
      fs.style.setProperty('outline', 'none', 'important');
      fs.style.setProperty('box-shadow', 'none', 'important');
    });

    // Ensure all file inputs accept JPG, PNG, and video for Windows
    const allFileInputs = formWrapper.querySelectorAll('input[type="file"]');
    allFileInputs.forEach(function (inp) {
      inp.setAttribute('accept', '.jpg,.jpeg,.png,.webp,.gif,.mp4,.mov,.m4v,.webm,image/*,video/*');
      inp.setAttribute('title', 'Upload photos or video');
      if (!inp.dataset.acceptHooked) {
        inp.dataset.acceptHooked = 'true';
        inp.addEventListener('click', function () {
          this.setAttribute('accept', '.jpg,.jpeg,.png,.webp,.gif,.mp4,.mov,.m4v,.webm,image/*,video/*');
        });
      }
    });

    const boxes = formWrapper.querySelectorAll('.jdgm-picture-fieldset__box, .jdgm-media-fieldset__box, [class*="picture-fieldset__box"]');
    if (!boxes || boxes.length === 0) return;

    boxes.forEach(function (box) {
      const boxWrapper = box.querySelector('.jdgm-picture-fieldset__box-wrapper') || box;

      // Hide all native Judge.me icons
      const nativeIcons = box.querySelectorAll('.jdgm-media-fieldset__icon, .jdgm-picture-fieldset__icon');
      nativeIcons.forEach(function (ic) {
        ic.style.setProperty('display', 'none', 'important');
      });

      const fileInput = box.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.setAttribute('accept', '.jpg,.jpeg,.png,.webp,.gif,.mp4,.mov,.m4v,.webm,image/*,video/*');
        fileInput.setAttribute('title', 'Upload photos or video');

        fileInput.style.setProperty('opacity', '0', 'important');
        fileInput.style.setProperty('position', 'absolute', 'important');
        fileInput.style.setProperty('top', '0', 'important');
        fileInput.style.setProperty('left', '0', 'important');
        fileInput.style.setProperty('right', '0', 'important');
        fileInput.style.setProperty('bottom', '0', 'important');
        fileInput.style.setProperty('width', '100%', 'important');
        fileInput.style.setProperty('height', '100%', 'important');
        fileInput.style.setProperty('cursor', 'pointer', 'important');
        fileInput.style.setProperty('z-index', '10', 'important');
        fileInput.style.setProperty('margin', '0', 'important');
        fileInput.style.setProperty('padding', '0', 'important');

        if (!fileInput.dataset.enhanceHooked) {
          fileInput.dataset.enhanceHooked = 'true';
          fileInput.addEventListener('change', function () {
            if (this.files && this.files.length > 0) {
              for (let i = 0; i < this.files.length; i++) {
                const f = this.files[i];
                if (!f.type || f.type === 'application/octet-stream') {
                  const ext = (f.name.split('.').pop() || '').toLowerCase();
                  let determinedType = '';
                  if (['jpg', 'jpeg'].includes(ext)) determinedType = 'image/jpeg';
                  else if (ext === 'png') determinedType = 'image/png';
                  else if (ext === 'webp') determinedType = 'image/webp';
                  else if (ext === 'gif') determinedType = 'image/gif';
                  else if (['mp4', 'mov', 'm4v', 'webm'].includes(ext)) determinedType = 'video/mp4';

                  if (determinedType) {
                    try {
                      Object.defineProperty(f, 'type', { value: determinedType, configurable: true });
                    } catch (e) {}
                  }
                }
              }
            }
            setTimeout(function () {
              enhanceMediaUpload(formWrapper);
            }, 150);
            setTimeout(function () {
              enhanceMediaUpload(formWrapper);
            }, 500);
          }, true);
        }
      }

      // Check if box has an uploaded preview image or delete button
      const bgImg = boxWrapper.style.backgroundImage;
      const hasPreview = boxWrapper.classList.contains('jdgm-has-preview-image') || 
                         (bgImg && bgImg !== 'none' && bgImg !== '') || 
                         box.querySelector('.jdgm-picture-fieldset__delete');

      const parentContainer = box.closest('.jdgm-media-fieldset__container, .jdgm-picture-fieldset__container') || box.parentElement;
      let customContent = boxWrapper.querySelector('.custom-upload-content');

      if (!hasPreview) {
        box.classList.add('is-empty-dropzone');
        box.classList.remove('is-preview-thumbnail');

        const isMultiBox = boxes.length > 1 && parentContainer && parentContainer.querySelectorAll('.is-preview-thumbnail').length > 0;

        if (!customContent) {
          customContent = document.createElement('div');
          customContent.className = 'custom-upload-content';
          boxWrapper.appendChild(customContent);
        }

        if (isMultiBox) {
          if (parentContainer) parentContainer.classList.add('has-previews');
          customContent.innerHTML = `
            <div class="custom-upload-add-more">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span>Add more</span>
            </div>
          `;
        } else {
          customContent.innerHTML = `
            <div class="custom-upload-icon-wrap">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
            </div>
            <div class="custom-upload-title">Upload Photos or Video</div>
            <div class="custom-upload-subtitle">Click to browse or drag and drop JPG, PNG, MP4</div>
          `;
        }
      } else {
        box.classList.add('is-preview-thumbnail');
        box.classList.remove('is-empty-dropzone');
        if (parentContainer) {
          parentContainer.classList.add('has-previews');
        }
        if (customContent) {
          customContent.remove();
        }

        const delBtn = box.querySelector('.jdgm-picture-fieldset__delete');
        if (delBtn && !delBtn.dataset.enhanceHooked) {
          delBtn.dataset.enhanceHooked = 'true';
          delBtn.addEventListener('click', function () {
            setTimeout(function () {
              enhanceMediaUpload(formWrapper);
            }, 200);
          });
        }
      }

      // Setup drag-and-drop visual hover
      if (!box.dataset.dragHooked) {
        box.dataset.dragHooked = 'true';
        box.addEventListener('dragover', function () {
          box.classList.add('is-drag-over');
        });
        box.addEventListener('dragleave', function () {
          box.classList.remove('is-drag-over');
        });
        box.addEventListener('drop', function () {
          box.classList.remove('is-drag-over');
        });
      }
    });
  }

  function enhanceReviewFormElements(formWrapper) {
    if (!formWrapper) return;

    // 1. Ensure Reviewer Name Format is clean and strictly inline
    const formatContainers = formWrapper.querySelectorAll('.jdgm-form__reviewer-name-format-container, [class*="reviewer-name-format"]');
    formatContainers.forEach(function (container) {
      container.style.setProperty('display', 'inline-flex', 'important');
      container.style.setProperty('align-items', 'center', 'important');
      container.style.setProperty('flex-wrap', 'wrap', 'important');
      container.style.setProperty('vertical-align', 'middle', 'important');

      const inlineLabels = container.querySelectorAll('label, .jdgm-form__inline-label');
      inlineLabels.forEach(function (lbl) {
        lbl.style.setProperty('display', 'inline', 'important');
        lbl.style.setProperty('margin', '0 3px', 'important');
        lbl.style.setProperty('padding', '0', 'important');
        lbl.style.setProperty('font-weight', '400', 'important');
        lbl.style.setProperty('color', '#555555', 'important');
      });

      const selects = container.querySelectorAll('select, .jdgm-form__reviewer-name-format-dropdown');
      selects.forEach(function (sel) {
        sel.style.setProperty('display', 'inline-block', 'important');
        sel.style.setProperty('width', 'auto', 'important');
        sel.style.setProperty('margin', '0', 'important');
        sel.style.setProperty('vertical-align', 'middle', 'important');
        sel.style.setProperty('color', '#b8860b', 'important');
      });
    });

    // Ensure parent name label has flex layout if it contains format container
    const nameLabels = formWrapper.querySelectorAll('label[for*="reviewer_name"], label[for*="name"]');
    nameLabels.forEach(function (lbl) {
      if (lbl.querySelector('.jdgm-form__reviewer-name-format-container, select')) {
        lbl.style.setProperty('display', 'flex', 'important');
        lbl.style.setProperty('align-items', 'center', 'important');
        lbl.style.setProperty('flex-wrap', 'wrap', 'important');
      }
    });
  }

  function closeReviewModal() {
    if (isOpeningModal) return;

    const overlay = document.querySelector('.custom-review-modal-overlay');
    if (overlay) {
      overlay.classList.remove('is-active');
      document.body.classList.remove('custom-modal-open');
    }

    const nativeBtn = document.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-btn, [class*="write-rev"]');
    if (nativeBtn) {
      nativeBtn.classList.remove('close-form-btn');
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  let reviewsObserver = null;
  function observeReviewsList(widget) {
    const reviewsList = widget.querySelector('.jdgm-rev-widg__reviews');
    if (!reviewsList || reviewsObserver) return;

    reviewsObserver = new MutationObserver(function (mutations) {
      let shouldEnhance = false;
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          shouldEnhance = true;
          break;
        }
      }
      if (shouldEnhance) {
        setTimeout(runEnhancer, 50);
      }
    });

    reviewsObserver.observe(reviewsList, { childList: true });
  }

  function setupEvents() {
    runEnhancer();

    let checks = 0;
    const pollInterval = setInterval(function () {
      checks++;
      runEnhancer();
      if (checks >= 25) {
        clearInterval(pollInterval);
      }
    }, 300);

    // Global click delegation for all "Write a Review" triggers
    document.addEventListener('click', function (e) {
      if (isTriggeringNativeClick) {
        return;
      }

      const writeTrigger = e.target.closest(
        '.custom-write-review-btn, .jdgm-write-rev-link, .jdgm-write-rev-btn, [class*="write-rev"], [data-action="write-review"], a[href*="#jdgm-write"]'
      );
      if (writeTrigger) {
        e.preventDefault();
        e.stopPropagation();
        const widget = writeTrigger.closest('.jdgm-rev-widg') || 
                       writeTrigger.closest('#judgeme_product_reviews') || 
                       document.querySelector('.jdgm-rev-widg');
        openReviewModal(widget);
        return;
      }

      const paginateLink = e.target.closest('.jdgm-paginate a, .jdgm-paginate__page');
      if (paginateLink) {
        // Smooth scroll to top of review section when navigating
        const widget = document.querySelector('.jdgm-rev-widg');
        if (widget) {
          const yOffset = -80;
          const y = widget.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }

        // Multiple fallback polls to guarantee re-enhancement after AJAX
        setTimeout(runEnhancer, 150);
        setTimeout(runEnhancer, 400);
        setTimeout(runEnhancer, 800);
        setTimeout(runEnhancer, 1400);
      }

      if (e.target.closest('.jdgm-histogram__row') || e.target.closest('.jdgm-sort-dropdown')) {
        setTimeout(runEnhancer, 300);
        setTimeout(runEnhancer, 800);
      }
    });

    // Observer to run enhancer whenever Judge.me injects or updates widgets
    if (window.MutationObserver) {
      const bodyObserver = new MutationObserver(function (mutations) {
        for (let i = 0; i < mutations.length; i++) {
          const added = mutations[i].addedNodes;
          for (let j = 0; j < added.length; j++) {
            const node = added[j];
            if (node.nodeType === 1 && !node.closest?.('.custom-review-modal-overlay') && !node.classList?.contains('custom-review-modal-overlay') && (
              node.classList?.contains('jdgm-rev-widg') ||
              node.classList?.contains('jdgm-widget') ||
              node.querySelector?.('.jdgm-rev-widg, .jdgm-widget')
            )) {
              runEnhancer();
              return;
            }
          }
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (typeof $ !== 'undefined') {
      $(document).on('variantSKUChange variantChange', function () {
        setTimeout(enhanceProductTitleBadge, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEvents);
  } else {
    setupEvents();
  }

  document.addEventListener('jdgm.doneSetup', runEnhancer);
})();
